import { getRouteApi } from '@tanstack/react-router';
import { useCallback } from 'react';

import { definedSearchParams } from '@/lib/search-params';

import { UserDetailScreen } from './UserDetailScreen';
import type { UserDetailSearch } from './user-detail-search';

const route = getRouteApi('/users/$userId');

export function UserDetailRoute() {
  const { userId } = route.useParams();
  const search = route.useSearch();
  const navigate = route.useNavigate();

  const onSearchChange = useCallback(
    (next: UserDetailSearch) => {
      void navigate({
        // Absent keys rather than explicit undefined, so a closed transcript
        // leaves the URL instead of lingering as `?session=`.
        search: () => definedSearchParams(next),
      });
    },
    [navigate],
  );

  return <UserDetailScreen userId={userId} search={search} onSearchChange={onSearchChange} />;
}
